import i18n from 'i18next';
import { system900, white } from 'Mui/styles/color';

export const ImageShowTypeMapping = {
    SQUARE: 1,
    WATERFALL: 2,
    SLIDERSHOW: 3,
    MARQUEE: 4,
    COLLAGE: 5
};

export const galleryGameSetting = {
    versionStyleSettings: {
        //網格式：1，瀑布流：2，幻燈片：3，跑馬燈：4，作品拼貼：5
        imgShowType: ImageShowTypeMapping.SQUARE,
        isShowWorkInformation: false
    },
    buttonSettings: {
        isShowButton: true,
        buttonText: i18n.t('btn.read_more'),
        textColor: white.color,
        bgColor: system900.color,
        maskColor: white.color
    }
};

export const squareFakeData = (igGame, isGallery) => {
    const getDefaultAvatarByType = (igGame, isGallery) => {
        if (igGame || isGallery) {
            return null;
        } else {
            return 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultOrigin.jpeg';
        }
    };
    let array = [];
    const fakeData1 = {
        avatar: getDefaultAvatarByType(igGame, isGallery),
        memberId: 123456,
        media: [
            {
                result: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultSquare.png',
                seq: 1,
                subtype: '',
                type: 'image'
            },
            {
                result: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultSquare.png',
                seq: 1,
                subtype: 'youtube',
                type: 'video'
            }
        ],
        ugcAuthorName: 'feversocial.tw',
        title: i18n.t('label.ugc.work_title')
    };
    const fakeData2 = {
        avatar: getDefaultAvatarByType(igGame, isGallery),
        memberId: 123456,
        media: [
            {
                result: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultOrigin.jpeg',
                seq: 1,
                subtype: '',
                type: 'image'
            },
            {
                result: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultOrigin.jpeg',
                seq: 1,
                subtype: 'youtube',
                type: 'video'
            }
        ],
        ugcAuthorName: 'feversocial.tw',
        title: i18n.t('label.ugc.work_title')
    };

    for (let i = 0; i < 6; i++) {
        array.push(fakeData1);
        array.push(fakeData2);
    }
    return array;
};

export const sliderShowFakeData = () => {
    let data = [];
    const fakeData1 = {
        uuid: 1,
        value: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultSquare.png'
    };
    const fakeData2 = {
        uuid: 2,
        value: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultSquare.png'
    };

    for (let i = 0; i < 3; i++) {
        data.push(fakeData1);
        data.push(fakeData2);
    }
    return data;
};

export const marqueeFakeData = () => {
    let data = [];
    const fakeData1 = {
        serialNo: 1,
        value: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultSquare.png'
    };
    const fakeData2 = {
        serialNo: 2,
        value: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultOrigin.jpeg'
    };

    for (let i = 0; i < 3; i++) {
        data.push(fakeData1);
        data.push(fakeData2);
    }

    let obj = { data: data, secondaryData: data };

    return obj;
};
